export default __webpack_public_path__ + "static/media/twb.0828a93c.jpg";